// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"hO","input":"hP","button":"hQ"};